namespace GeniuzPOS.ReportMasterData {
    export namespace Report_1503_NService {
        export const baseUrl = 'ReportMasterData/Report_1503_N';

        export declare function Create(request: Serenity.SaveRequest<Report_1503_NRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<Report_1503_NRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Report_1503_NRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<Report_1503_NRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ReportMasterData/Report_1503_N/Create",
            Update = "ReportMasterData/Report_1503_N/Update",
            Delete = "ReportMasterData/Report_1503_N/Delete",
            Retrieve = "ReportMasterData/Report_1503_N/Retrieve",
            List = "ReportMasterData/Report_1503_N/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>Report_1503_NService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
